import { Component, OnInit, ViewChild, ChangeDetectorRef, Directive } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { PersonNameService } from "../services/personname.service";
import { Person } from '../models/person.model';
import { Router } from '@angular/router';
import { OrganizationComponent } from './organization/organization.component';
import { Organization } from '../models/organization.model';
import { OrganizationService } from '../services/organization.service';
import { LocalStoreManager } from '../services/local-store-manager.service';
import { ReportParam } from '../models/reportparam.model';
import { PrintReportParam } from '../models/printreportparam.model';
import { AlertService } from '../services/alert.service';
import { AppTranslationService } from "../services/app-translation.service";
import { DataService } from '../services/data.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NgxSpinnerService } from "ngx-spinner";
import { HttpResponse } from '@angular/common/http';

@Component({
    template: '',
    standalone: false
})
export abstract class BaseReportComponent implements OnInit {

  constructor(
    public dialog: MatDialog,
    public dataservice: DataService,
    public personNameService: PersonNameService,
    public localStorage: LocalStoreManager,
    public translationService: AppTranslationService,
    public organizationService: OrganizationService,
    public alertService: AlertService,
    public router: Router,
    public spinner: NgxSpinnerService,
    protected cdr: ChangeDetectorRef) {
  }

  organizationTree: OrganizationComponent = new OrganizationComponent(this.dataservice, this.organizationService, null, null, null);
  //newOrganization: Organization[] = [];
  reportid: number = 0;
  selectedDate: Date;
  public dateNow: Date = new Date(); // Today's date as a Date object
  public dateToday: Date = new Date();
  public dateOlder: Date = this.getOlderDate();
  personIndex: number;
  selectedPerson: Person;
  persons: Person[] = [];
  personids: Array<number>;
  guser: boolean;
  ownDataVisible: boolean;
  personCount: number;
  reportRights: number;
  personname: string;
  employeeId: string;
  params = new ReportParam();
  locale: string;
  hasOrganization: boolean;
  userRights: number;
  refreshToolTip: string;
  pdfToolTip: string;
  excelToolTip: string;
  withHeader: boolean;
  printparams = new PrintReportParam();
  public startDate: Date = new Date(
    this.dateOlder.getFullYear(),
    this.dateOlder.getMonth(), // Month is already zero-based in Date objects
    this.dateOlder.getDate()
  );
  public endDate: Date = new Date(
    this.dateNow.getFullYear(),
    this.dateNow.getMonth(), // Month is already zero-based in Date objects
    this.dateNow.getDate()
  );
  public stampDate: Date = new Date(
    this.dateNow.getFullYear(),
    this.dateNow.getMonth(), // Month is already zero-based in Date objects
    this.dateNow.getDate()
  );
  emptyMess = this.translationService.getTranslation('helps.NoDataToDisplay');
  selectNameStr = this.translationService.getTranslation('stampreport.SelectName');
 
  ngOnInit(): void {
    this.locale = this.localStorage.getDataObject("language");
    this.guser = this.localStorage.getDataObject("guser");
    this.reportRights = this.localStorage.getDataObject("reportrights");
    this.personCount = this.localStorage.getDataObject("personcount");
    this.ownDataVisible = (this.reportRights&32768) == 32768;
    this.hasOrganization = this.localStorage.getDataObject("orgright");
    this.userRights = this.localStorage.getDataObject("userrights");
    this.refreshToolTip = this.translationService.getTranslation('common.refreshToolTip');
    this.pdfToolTip = this.translationService.getTranslation('common.pdfToolTip');
    this.excelToolTip = this.translationService.getTranslation('common.excelToolTip');
    this.personIndex = -1;
    this.employeeId = null;
    this.dataservice.StampDate = this.stampDate;
    if (this.dataservice.PersonIndex >= 0) {
      this.personIndex = this.dataservice.PersonIndex;
      this.startDate = this.dataservice.StartDate ?? this.startDate;
      this.endDate = this.dataservice.EndDate ?? this.endDate;
    }
    this.GUserSettings();
    if (!this.guser)
      this.personNameService.getpersonnames("")
        .subscribe(results => {
          this.persons = results;
          if (this.dataservice.PersonData) {
            this.selectedPerson = this.dataservice.PersonData;
            this.employeeId = this.dataservice.PersonData.employeeId;
            this.personIndex = this.dataservice.PersonIndex;
          }
          else {
            if (this.persons.length > 0) {
              this.selectedPerson = this.persons[0];
              this.employeeId = this.persons[0].employeeId;
              this.personIndex = 0;
            }
          }
        },
          (error: any) => {
            console.log(error);
          });

  }

  GUserSettings() {
    this.guser = this.guser && this.personCount <= 1 && this.ownDataVisible;
    if (this.guser) {
      this.personname = this.localStorage.getDataObject("personname");
      this.getPersonNames(this.localStorage.getDataObject("employee_id"));
      this.params.employee_id = this.localStorage.getDataObject("employee_id");
      this.params.lang = this.localStorage.getDataObject("language");
    }
  }

  getToday(): Date {
    const today = new Date();
    this.dateToday = today; // Save it if you need it elsewhere
    return today;
  }

  getOlderDate(): Date {
    const date = new Date();
    date.setDate(date.getDate() - 7); // Subtract 7 days
    return date; // Return the updated Date object
  }

  onDateChange1(newDate: Date): void {
    if (newDate) {
      this.startDate = new Date(newDate); // Create a new reference
      console.log('Date changed in BaseReportComponent:', this.startDate);
      this.cdr.detectChanges(); // Force Angular to detect changes
    }
  }

  onDateChange2(newDate: Date): void {
    if (newDate) {
      this.endDate = new Date(newDate); // Create a new reference
      console.log('Date changed to:', this.startDate);
      this.cdr.detectChanges(); // Force Angular to detect changes
    }
  }

  changePerson() {
    if (this.persons != null && this.selectedPerson != null) {
      this.personIndex = this.persons.indexOf(this.selectedPerson);
      if (this.personIndex < 0)
        this.personIndex = 0;
      this.employeeId = this.persons[this.personIndex].employeeId;
    }
  }

  clearPersonList() {
    this.persons = [];
    this.selectedPerson = null;
    this.personIndex = -1;
    this.employeeId = null;
  }

  clearPerson() {
    this.selectedPerson = null;
    this.personIndex = -1;
    this.employeeId = null;
  }

  previousname() {
    if (this.personIndex > 0) {
      this.personIndex--;
      this.selectedPerson = this.persons[this.personIndex];
      this.employeeId = this.persons[this.personIndex].employeeId;
    }
  }

  nextname() {
    if (this.personIndex < this.persons.length - 1) {
      this.personIndex++;
      this.selectedPerson = this.persons[this.personIndex];
      this.employeeId = this.persons[this.personIndex].employeeId;
    }
  }

  getPersonNames(personid: string) {
    this.personNameService.getpersonnames(personid)
      .subscribe(results => {
        this.persons = results;
      },
        (error: any) => {
          console.log(error);
        });
  }

  setReportDate(offset: number): Date {
    const date = new Date(); // Get the current date
    date.setDate(date.getDate() - offset); // Subtract the offset from the current date
    return date; // Return the updated Date object
  }

  stampReportParameters() {
    this.params.lang = this.localStorage.getDataObject("language");
    // Format startDate
    if (this.startDate) {
      const d = this.startDate;
      this.params.startDate = ("0" + d.getDate()).slice(-2) + "." + ("0" + (d.getMonth() + 1)).slice(-2) + "." + d.getFullYear();
    }

    // Format endDate
    if (this.endDate) {
      const d = this.endDate;
      this.params.endDate = ("0" + d.getDate()).slice(-2) + "." + ("0" + (d.getMonth() + 1)).slice(-2) + "." + d.getFullYear();
    }
  }


  checkReportDates(): boolean {
    const sd = this.startDate.getTime(); // Convert startDate to timestamp
    const ed = this.endDate.getTime();   // Convert endDate to timestamp

    if (sd > ed) {
      this.alertService.showDialog(this.translationService.getTranslation('Errormessage.EndDateBeforeStartDate'));
      return false;
    }
    return true;
  }

  openDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.height = '600px';
    dialogConfig.width = '600px';
    dialogConfig.data = {
    };
    const dialogRef = this.dialog.open(OrganizationComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result: string) => {
      this.organizationTree.newOrganization = this.dataservice.editedOrganization;
      if (this.organizationTree.newOrganization.length == 0) {
        this.persons = null;
        this.selectedPerson = null;
      }
      else
        this.personNameService.getorganizationpersonnames(this.organizationTree.newOrganization)
          .subscribe(results => {
            this.persons = results;
            if (this.persons.length == 0) {
              this.selectedPerson = null;
            }
            else {
              this.selectedPerson = this.persons[0];
            }
          },
            (error: any) => {
              console.log(error);
            });
    });
  }

  public printEmployeeParams(all: number) {
    if (!this.checkReportDates())
      return;
    if (!this.guser) {
      this.printparams.employee_id = [];
      if (all == 1) {
        for (var i = 0, len = this.persons.length; i < len; i++) {
          this.printparams.employee_id[i] = this.persons[i].employeeId;
        }
      }
      else {
        this.printparams.employee_id[0] = this.selectedPerson.employeeId;
        this.personname = this.selectedPerson.name;
      }
    }
    else {
      this.printparams.employee_id[0] = this.params.employee_id; // this.selectedPerson.employeeId;
    }
  }

  public printParameters() {
    this.stampReportParameters();
    this.printparams.reportType = this.reportid;
    this.printparams.startDate = this.params.startDate;
    this.printparams.endDate = this.params.endDate;
    this.printparams.lang = this.params.lang;
  }

  // Function to extract the filename from the response headers
  public getFilenameFromResponse(response: HttpResponse<Blob>): string {
    const contentDispositionHeader = response.headers.get('Content-Disposition');
    if (contentDispositionHeader) {
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(contentDispositionHeader);
      if (matches != null && matches[1]) {
        return matches[1].replace(/['"]/g, '');
      }
    }
    return '';
  }
}
